module.exports = __webpack_public_path__ + "img/2.bf02c309.jpg";